import React, {PureComponent} from "react";

interface Props {
    message: JSX.Element;
    onClose: () => void;
}

export default class ErrorAlert extends PureComponent<Props> {
    render(): JSX.Element {
        return (
            <div className="errorAlert">
                <p>{this.props.message}</p>
                <button type="button" className="errorAlertClose" aria-label="Close this dialog" onClick={this.props.onClose}>
                    ×
                </button>
            </div>
        );
    }
}